import styled from 'styled-components'
import {Box, Typography} from '@mui/material'
import theme, {colors} from '../../styles/theme'

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
  }
`

export const LeftHeader = styled(Box)``

export const RightHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;

  && img {
    cursor: pointer;
  }

  ${theme.breakpoints.down('sm')} {
    flex-basis: 100%;
    margin-top: 16px;
  }
`

export const HeaderTitle = styled(Typography)`
  text-transform: none !important;
  font-size: 24px !important;
  color: ${colors.bksBlack} !important;
  display: flex !important;
  align-items: center !important;
  font-weight: 700 !important;
  gap: 8px !important;

  && img {
    height: 12px;
  }
`

export const ItemTitle = styled(Typography)`
  text-transform: none !important;
  font-size: 24px !important;
  color: #2d2d2d !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
`

export const SubTitle = styled(Typography)`
  font-family: Public Sans !important;
  text-transform: none !important;
  font-size: 12px !important;
  color: ${colors.coolGray60} !important;
`

export const DownloadButton = styled(Box)`
  border-radius: 2px;
  border: 1px solid #ebeffc;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  background: ${colors.white};
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const DateButton = styled(Box)<{$isActive?: boolean}>`
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  height: 24px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    color 0.15s,
    background-color 0.15s;
  font-weight: bold;

  ${({$isActive}) =>
    $isActive
      ? `background-color: ${colors.blue1}; color: ${colors.white};`
      : `background-color: #F6F6F6; color: ${colors.bksGray80};`}

  &:hover {
    background-color: ${colors.blue1};
    color: ${colors.white};
  }
`

export const NumbersBox = styled(Box)`
  display: flex;
  justify-content: space-around;
`

export const NumberItem = styled(Box)<{$isLink?: boolean}>`
  display: flex;
  flex-flow: column;
  gap: 8px;
  align-items: center;
  width: 200px;

  ${({$isLink}) =>
    $isLink
      ? `
		cursor: pointer;
		color: #1377D4;

		&:hover {
			color: #23527c;
		}
	`
      : null}
`

export const NumberTitle = styled(Box)`
  text-transform: uppercase;
  font-size: 14px;
`

export const NumberSubTitle = styled(Box)`
  font-size: 36px;
`

export const SpacingBox = styled(Box)`
  margin-top: 32px;
`

export const PaperCard = styled(Box)`
  border-radius: 2px;
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeffc;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  && th {
    font-size: 16px !important;
    color: ${colors.bksGray80} !important;
    font-weight: 700 !important;
    padding: 20px 20px 12px !important;
  }
`

export const LeftLegend = styled.span`
  font-size: 12px;
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%) rotate(270deg);
  color: ${colors.bksGray80};

  ${theme.breakpoints.down('sm')} {
    left: -50px;
  }
`

export const RightLegend = styled.span`
  font-size: 12px;
  position: absolute;
  right: -60px;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
  color: ${colors.bksGray80};

  ${theme.breakpoints.down('sm')} {
    right: -45px;
  }
`

export const BottomLegend = styled.span`
  font-size: 12px;
  display: flex;
  width: 100%;
  justify-content: center;
  color: ${colors.bksGray80};
`

export const OverviewBox = styled(Box)`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  ${theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
  }
`

export const OverviewCard = styled(Box)`
  border-radius: 2px;
  border: 1px solid #ebeffc;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  flex-flow: column;
  gap: 16px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  ${theme.breakpoints.down('sm')} {
    flex: 1 1 50%;
  }
`

export const OverviewTitle = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;

  && img {
    height: 12px;
  }
`

export const OverviewContent = styled(Typography)<{type?: 'up' | 'down' | ''}>`
  display: flex;
  gap: 8px;
  font-size: 24px !important;
  font-weight: 700 !important;
  align-items: baseline;

  && span {
    font-size: 12px;

    display: flex;
    align-items: center;
    gap: 4px;

    ${({type}) =>
      type === 'up'
        ? `
        color: ${colors.seaGreen} !important;
    `
        : type === 'down'
        ? `color: ${colors.crimsonRed} !important;`
        : null}
  }
`

export const LegendBox = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`

export const LegendItem = styled(Box)<{$legendColor: string}>`
  border-radius: 4px;
  border-left: 6px solid #008900;
  border-top: 1px solid #ebeffc;
  border-right: 1px solid #ebeffc;
  border-bottom: 1px solid #ebeffc;

  ${({$legendColor}) =>
    $legendColor
      ? `border-left: 6px solid ${$legendColor};`
      : `border-left: 1px solid #EBEFFC;`}

  height: 31px;
  font-size: 12px;
  align-items: center;
  display: flex;
  padding: 0 8px;
`

export const TabsBox = styled(Box)`
  border-bottom: 1px solid #ebeffc;
  margin-top: 48px;

  && .MuiTab-root {
    text-transform: none;
    color: ${colors.bksGray40};
  }

  && .Mui-selected {
    color: ${colors.bksGray80} !important;
    font-weight: 700 !important;
  }

  && .MuiTabs-indicator {
    background-color: ${colors.blue1}!important;
  }
`

export const FlexBox = styled(Box)`
  display: flex;
  gap: 32px;
  width: 100%;
  margin-top: 48px;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
  }
`

export const ProgressBarBox = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;

  && .MuiLinearProgress-root {
    height: 9px;
    border-radius: 6px;
    width: 100%;

    span {
      background-color: ${colors.blue1};
    }
  }

  && img {
    width: 30px;
  }
`

export const DivisionListBox = styled(Box)`
  margin-top: 8px;
  display: flex;
  flex-flow: column;
  gap: 8px;
`

export const VersusBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`

export const VersusItems = styled(Box)`
  display: flex;
  flex-flow: column;
  gap: 32px;
`

export const VersusItem = styled(Box)<{$legendColor: string}>`
  display: flex;
  flex-flow: column;
  padding-left: 8px;
  width: 100%;

  && span {
    font-size: 12px;
    color: ${colors.bksGray40};
    font-weight: 400;
  }

  ${({$legendColor}) =>
    $legendColor ? `border-left: 8px solid ${$legendColor};` : null}
`

export const PieChartBox = styled(Box)`
  display: flex;
  align-items: center;
`

export const SummaryFlexBox = styled(Box)`
  display: flex;
  gap: 32px;
  margin-top: 8px;

  ${theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
  }
`

export const CETitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #ff9363;
  text-align: center;
`
export const PATitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #7e7adf;
  text-align: center;
`
export const PCMTitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #00ccf8;
  text-align: center;
`
export const PJMTitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #c56ac4;
  text-align: center;
`
export const PPDTitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #abd264;
  text-align: center;
`
export const PDDTitle = styled.div`
  width: 37px;
  height: 28px;
  border-bottom: 3px solid #f16977;
  text-align: center;
`

export const TableHint = styled.span`
  font-size: 10px;
  color: ${colors.bksGray80};
`

export const TableSuccess = styled.span`
  font-size: 10px;
  color: ${colors.indiaGreen};
`

export const TableError = styled.span`
  font-size: 10px;
  color: ${colors.crimsonRed};
`

export const LicensedBox = styled.div`
  border-radius: 2px;
  background: #1377d4;
  width: 70px;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 10px;
  justify-content: center;

  && img {
    width: 14px;
  }
`

export const ExamChartFlexBox = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    gap: 32px;
  }
`

export const ExamChartLeftBox = styled(Box)`
  display: flex;
  flex-flow: column;
  gap: 16px;
  width: 40%;
  align-items: center;
`
export const ExamChartRightBox = styled(Box)`
  width: 60%;
`

export const Divider = styled(Box)`
  height: 1px;
  width: 100%;
  background-color: #ebeffc;
  margin: 16px 0;
`

export const LicensureButtonDisabled = styled.button`
  border: 0;
  background: 0;
  font-size: 14px;
  color: #d9d9d9;
  font-family: Public Sans;

  display: flex;
  align-items: center;
  gap: 8px;

  && span {
    display: flex;
    align-items: center;
  }
`

export const LicensureButton = styled.button`
  border: 0;
  background: 0;
  font-size: 14px;
  color: ${colors.bksGray40};
  font-family: Public Sans;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  && span {
    display: flex;
    align-items: center;
  }
`

export const PaginationText = styled.span`
  font-size: 14px;
  color: ${colors.bksGray40};
  font-family: Public Sans;
`

export const StyledSelect = styled.select`
  appearance: none;
  border-radius: 4px;
  border: 1px solid #dadada;
  background: #fff;
  color: ${colors.bksGray80};
  font-size: 12px;
  width: 110px;
  height: 33px;
  cursor: pointer;
  padding-left: 8px;
  font-weight: 700;
`

export const ArrowDown = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`
